// 可以下载的csv模板
export const downCSVTemplate = (
  name: string,
  data: ReadonlyArray<ReadonlyArray<string>>
) => {
  // let csvContent = 'data:text/csv;charset=utf-8,';
  let csvContent = '\uFEFF';
  data.forEach((row) => {
    csvContent += `${row.join(',')}\n`;
  });
  // const encodedUri = encodeURI(csvContent);
  const csvData = new Blob([csvContent], { type: 'text/csv' });
  const encodedUri = URL.createObjectURL(csvData);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${name}.csv`);
  document.body.appendChild(link);
  link.click();
};
